export default function guest({ next, store }) {
  if (store.state.user) {
    return next({ name: 'subscription' })
  }
  return next()
}
